import * as adjustDetail from '../services/adjustDetail';

export default {
  namespace: 'adjustDetail',

  state: {
    // userInfo: null,
    // memberPageList: null,
    // addMember: null,
    levels: [],
  },

  effects: {
    //获取该会员详情
    *getMemberDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustDetail.getMemberDetail, values);
      yield put({
        type: 'save',
        payload: {
          memberDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    //获取门店列表
    *getStoreList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustDetail.getStoreList, values);
      yield put({
        type: 'save',
        payload: {
          storeList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //更新会员详情
    *updateMemberDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustDetail.updateMemberDetail, values);
      yield put({
        type: 'save',
        payload: {
          // storeList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //积分历史
    *getIntegralHistory({ payload: { values } }, { call, put }) {
      const response = yield call(adjustDetail.getIntegralHistory, values);
      yield put({
        type: 'save',
        payload: {
          integralHistory: response?.data,
        },
      });
    },
    //积分历史
    *getIntegralHistoryMolding({ payload: { values } }, { call, put }) {
      const response = yield call(
        adjustDetail.getIntegralHistoryMolding,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          integralHistoryMolding: response?.data,
        },
      });
    },
    //会员异动
    *memberManualOperation({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustDetail.memberManualOperation, values);
      yield put({
        type: 'save',
        payload: {
          memberManualOperation: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //会员批量异动
    *batchMemberManualOperation({ payload: { values }, callback }, { call }) {
      const response = yield call(
        adjustDetail.batchMemberManualOperation,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // //获取总数据条数
    // *getTotalData({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(adjustDetail.getTotalData, values);
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       totalData: response?.data,
    //     },
    //   });
    //   if (callback && typeof callback === 'function') {
    //     return callback(response);
    //   }
    // },

    *getLevels(_, { call, put }) {
      const response = yield call(adjustDetail.getLevels);
      yield put({
        type: 'save',
        payload: {
          levels: response?.data,
        },
      });
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(adjustDetail.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/adjust/edit' ||
          props.pathname === '/adjust/changeStore' ||
          props.pathname === '/adjust/changeLevel' ||
          props.pathname === '/adjust/changeIntegral'
        ) {
          dispatch({
            type: 'save',
            payload: {
              memberDetail: {},
            },
          });
        }
      });
    },
  },
};
